import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Helpers/config.json";

import ReusableDashboardHeader from "../../Containers/Dasboard/ReusableDashboardHeader";
import { BackButton } from "../../Utils/FormInputs/BackButton";
import TextField from "../../Utils/FormInputs/TextField";
import Label from "../../Utils/FormInputs/Label";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { useMuiPagination } from "../../Containers/Dasboard/DashboardTables";
import {
  EnhancedTableHead,
  EnhancedTableToolbar,
  MuiPagination,
  MuiPaper,
} from "../../Utils/Tables/CustomTable";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableContainer from "@material-ui/core/TableContainer";

import { titleCase } from "../../Utils/titleCaseFunction";
import { dateConvert } from "../../Utils/ConvertDate";
import { LoadingGif } from "../../Utils/Loader";
import { ErrorMessage } from "../../Utils/styledComponents";

const ADJUSTMENT_REASONS = [
  { value: "", text: "Select Reason..." },
  { value: "Donation Drugs", text: "Donation Drugs" },
  { value: "Short Delivery", text: "Short Delivery" },
  { value: "Excess Delivery", text: "Excess Delivery" },
  { value: "Damaged Goods", text: "Damaged Goods" },
  { value: "Expired Goods", text: "Expired Goods" },
  { value: "Wrong Quantity Entered", text: "Wrong Quantity Entered" },
  { value: "Price Correction", text: "Price Correction" },
  { value: "Supplier Revised Invoice", text: "Supplier Revised Invoice" },
  { value: "Batch Number Correction", text: "Batch Number Correction" },
  { value: "Expiry Date Correction", text: "Expiry Date Correction" },
  { value: "Wrong Supplier", text: "Wrong Supplier" },
  { value: "Wrong Invoice/Chalan Number", text: "Wrong Invoice/Chalan Number" },
  { value: "Date Correction", text: "Date Correction" },
  { value: "Stock Reconciliation", text: "Stock Reconciliation" },
  { value: "Return to Supplier", text: "Return to Supplier" },
  { value: "Data Entry Mistake", text: "Data Entry Mistake" },

  { value: "Others", text: "Others" },
];

const headData = [
  { id: "date", label: "Date" },
  { id: "product", label: "Product" },
  { id: "batch", label: "Batch #" },
  { id: "reason", label: "Reason" },
  { id: "type", label: "Type" },
  { id: "quantity", numeric: true, label: "Quantity" },
  { id: "unit_cost", numeric: true, label: "Unit Cost" },
  { id: "total_cost", numeric: true, label: "Total Cost" },
  { id: "adjusted_by", label: "Adjusted By" },
];

const NewStockAdjustmentReport = () => {
  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, setPage } = useMuiPagination();

  const today = new Date().toISOString().split("T")[0];

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [selectedReason, setSelectedReason] = useState("All");

  const fetchData = () => {
    setLoading(true);
    axios
      .get(`${config.epharmUrl}/Creport/stock_adjustment_report`, {
        params: {
          page: page + 1,
          search: search || null,
          start_date: fromDate || null,
          end_date: toDate || null,
          reason: selectedReason,
        },
      })
      .then((res) => {
        const resp = res.data;
        setData(resp.adjustments || []);
        setTotalCount(resp.total_count || 0);
        setTotalQuantity(resp.total_quantity || 0);
        setTotalCost(resp.total_cost || 0);
        setLoading(false);
      })
      .catch((err) => {
        ErrorMessage(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [page, search, fromDate, toDate, selectedReason]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setPage(0);
    fetchData();
  };

  return (
    <div className="journals">
      <ReusableDashboardHeader
        component="Stock Adjustment Report"
        heading="Reports"
        subHeading="Stock Adjustment"
        link="/reports"
      />

      <div className="general-ledger-header mb-3">
        <BackButton text="Reports" to="/allreports" />

        <form onSubmit={handleSearchSubmit}>
          <Form.Group as={Row} className="mb-3">
            <Col sm={3}>
              <Label name="From" />
              <TextField 
                type="date" 
                value={fromDate} 
                onChange={(e) => setFromDate(e.target.value)} 
              />
            </Col>
            <Col sm={3}>
              <Label name="To" />
              <TextField 
                type="date" 
                value={toDate} 
                onChange={(e) => setToDate(e.target.value)} 
              />
            </Col>
            <Col sm={3}>
              <Label name="Reason" />
              <select
                className="form-control"
                value={selectedReason}
                onChange={(e) => setSelectedReason(e.target.value)}
              >
                {ADJUSTMENT_REASONS.map((r) => (
                  <option key={r.value} value={r.value}>
                    {r.text}
                  </option>
                ))}
              </select>
            </Col>
            <Col sm={2}>
              <Label name="Search" />
              <TextField
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Product or Batch"
              />
            </Col>
            <Col sm={1} className="d-flex align-items-end">
              <button type="submit" className="btn btn-sm pharmacy-btn-outline">
                Filter
              </button>
            </Col>
          </Form.Group>
        </form>
      </div>

      {/* Summary */}
      <div className="alert alert-info mb-4">
        <strong>Total Adjustments:</strong> {totalQuantity.toFixed(2)} units &nbsp;|&nbsp;
        <strong>Total Value:</strong> USh {Number(totalCost).toLocaleString()}
      </div>

      <MuiPaper>
        <EnhancedTableToolbar title="Stock Adjustments" />
        <TableContainer>
          <Table>
            <EnhancedTableHead headCells={headData} />
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    <LoadingGif />
                  </TableCell>
                </TableRow>
              ) : data.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    No adjustments found
                  </TableCell>
                </TableRow>
              ) : (
                data.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{dateConvert(item.date_created)}</TableCell>
                    <TableCell>{titleCase(item.product_name)}</TableCell>
                    <TableCell>{item.batch_id}</TableCell>
                    <TableCell>{titleCase(item.reason)}</TableCell>
                    <TableCell>{item.adjustment_type}</TableCell>
                    <TableCell align="right">{item.quantity}</TableCell>
                    <TableCell align="right">{Number(item.unit_cost).toLocaleString()}</TableCell>
                    <TableCell align="right" style={{ fontWeight: "bold" }}>
                      {Number(item.total_cost).toLocaleString()}
                    </TableCell>
                    <TableCell>{titleCase(item.created_by)}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>

          <MuiPagination
            data={data}
            total_count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            rows={[10, 25, 50, 100]}
            colSpan={9}
          />
        </TableContainer>
      </MuiPaper>
    </div>
  );
};

export default NewStockAdjustmentReport;